<template>
    <button
        type="button"
        @click="$emit('click')"
        :disabled="disabled"
        class=" tw-w-full tw-bg-brand tw-p-2 tw-my-2 tw-rounded-sm tw-text-white tw-font-thin hover:tw-bg-red-700"
        :class="additionalClasses()"
    >
        <slot />
    </button>
</template>

<script>
	export default {
		name: 'CustomButton',
        props: {
		    disabled: {
		        type: Boolean,
                required: false,
                default: false,
            },
            bottomCenter: {
		        type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
		    additionalClasses() {
		        return {
		            "bottom-center": this.bottomCenter,
                }
            }
        }
    }
</script>

<style scoped>
    button:disabled {
        opacity: 50%;
    }

    .bottom-center {
        position: absolute;
        bottom: 70px;
        left: 50%;
        transform: translate(-50%);
    }
</style>